
const getFlightDuration = (departing_at, arriving_at) => {
    const dep = new Date(departing_at);
    const arr = new Date(arriving_at);
    const dur = arr - dep;
    const diff = new Date(dur);
    if (diff.getHours() === 0) {
        return `${diff.getMinutes()}m`;
    }
    else {
        return `${diff.getHours() - 1}h ${diff.getMinutes()}m`;
    }
    
}

export default getFlightDuration;